import React from 'react';
import PropTypes from 'prop-types';
import { useFela } from 'react-fela';

const rules = ({ theme, width }) => ({
  width: theme.margin[width] || width,
});

const Spacer = ({ width }) => {
  const { css } = useFela({ width });

  return (
    <div className={css(rules)} />
  );
};

Spacer.propTypes = {
  width: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
};

export default React.memo(Spacer);
